module.exports = __webpack_public_path__ + "img/chevron-left.ccf835fb.svg";